import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarrierResdit7421PerformanceReport from '../../components/CarrierResdit7421PerformanceReport';
import {
  getPercentageColumns,
  getNumberColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CarrierResdit7421PerformanceOperatorSelectors';
import CarrierResdit7421PerformanceOperatorReportMode from './CarrierResdit7421PerformanceOperatorReportMode';

const MODE_TABS = [
  { value: CarrierResdit7421PerformanceOperatorReportMode.percentage, label: '%' },
  { value: CarrierResdit7421PerformanceOperatorReportMode.number, label: '#' },
];

export class CarrierResdit7421PerformanceOperatorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: CarrierResdit7421PerformanceOperatorReportMode.percentage,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderPercentage() {
    return (
      <CarrierResdit7421PerformanceReport
        reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id}
        columns={this.props.percentageColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarrierResdit7421PerformanceOperatorReportMode.percentage}
      />
    );
  }

  renderNumber() {
    return (
      <CarrierResdit7421PerformanceReport
        reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id}
        columns={this.props.numberColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarrierResdit7421PerformanceOperatorReportMode.number}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case CarrierResdit7421PerformanceOperatorReportMode.percentage:
        return this.renderPercentage();
      case CarrierResdit7421PerformanceOperatorReportMode.number:
        return this.renderNumber();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    percentageColumns: getPercentageColumns(state),
    numberColumns: getNumberColumns(state),
  };
}

CarrierResdit7421PerformanceOperatorContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  percentageColumns: PropTypes.arrayOf(PropTypes.object),
  numberColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarrierResdit7421PerformanceOperatorContainer);
